import {Component, Input} from '@angular/core';
import {Base} from '../../../common/model/base.model';

@Component({
    selector: 'app-show-multi',
    template: `
      <app-show-layout [label]="label">
        <div *ngIf="!values || values.length == 0"><em class="text-secondary">Nessun elemento associato</em></div>
        <ul class="list-group">
          <li class="list-group-item pt-1 pb-1" *ngFor="let value of values"> 
            <div *ngIf="template" [innerHtml]=template(value)></div>
            <div *ngIf="!template">
              {{ value.getLabel() }}
            </div>
          </li>
        </ul>
      </app-show-layout>
  `,
    standalone: false
})
export class ShowMultiComponent {

  @Input() label;
  @Input() values: Base[];
  @Input() template: () => string;

}
